import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BBResponseContainer } from "../carrier/response-container";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { tap } from 'rxjs/operators';

@Injectable()
export class SearchOrderService {

    defaultTimeout = 600000;

    constructor(private http: HttpClient) { }

    /**
   * @function
   * @param lab
   * @param startPage
   * @param tubeBarcode
   * @description Make service call to get searched tube carriers for given lab and given tube barcode
   * this call always brings defined number of records for given page index (start page) as
   * part of lazy loading
   * this call supports partial(like search) and full search of tube barcodes
  */
    getOrderDetails(searchItem: string): Observable<BBResponseContainer> {

        let url = environment.BB_ORDERRECEPTION_SERVICE_URL + 'searchOrder';
        let requestParam = new HttpParams().set('searchItem', searchItem.toString());
    
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
          error.url = url;
        }));
    }
                
}